import { defineStore } from "pinia";
import { ref } from "vue";
import { getSprite } from "@/APIs/spriteSource";

export const useSpriteStore = defineStore("sprite", () => {
  const query = ref<string>("first"); // Might be used later to customize sprite.
  const iters = ref<number>(5); // Might be used later to customize sprite.
  const currentSprite = ref<string>("");
  const isLoading = ref<boolean>(false);
  const error = ref<string>("");

  const getRandomSprite = () => {
    isLoading.value = true;
    const q = (Math.random() + 1).toString(36).substring(7);
    getSprite(q, iters.value)
      .then((res) => {
        currentSprite.value = res;
        isLoading.value = false;
      })
      .catch((e) => {
        console.log("Failed to get new sprite, error: ", e);
        error.value = e;
        isLoading.value = false;
      });
  };

  getRandomSprite();

  return { currentSprite, isLoading, getRandomSprite, error };
});
